export const AVATAR_COLORS = [
  "#037f4c",
  "#00c875",
  "#9cd326",
  "#cab641",
  "#ffcb00",
  "#fdab3d",
  "#ff6d3b",
  "#ffadad",
  "#ff7575",
  "#df2f4a",
  "#bb3354",
  "#e50073",
  "#ff5ac4",
  "#faa1f1",
  "#9d50dd",
  "#784bd1",
  "#7e3b8a",
  "#401694",
  "#5559df",
  "#225091",
  "#579bfc",
  "#007eb5",
  "#4eccc6",
  "#66ccff",
  "#74afcc",
  "#9aadbd",
  "#c4c4c4",
  "#757575",
  "#333333",
  "#7f5347",
  "#e484bd",
  "#bca58a",
  "#a1e3f6",
  "#cd9282",
  "#216edf",
  "#175a63",
  "#bda8f9",
  "#a9bee8",
  "#9d99b9",
  "#563e3e",
];
